var _style, _circle, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 142 140.2",
    style: {
      enableBackground: "new 0 0 142 140.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#CECDD3;}\n\t.st2{fill:#1F1D30;}\n\t.st3{fill:#6D2DE0;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 71,
    cy: 70.1,
    r: 59.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M61.7,51c-3.3,0-10,0-11.1,0l-0.6,0l0,1.3c0.1,6.3,1.3,11.4,5.2,15.8c4.5,5.2,11,6.7,16.8,9.8 c2.1,1.1,4.4,2.5,4.4,5.1c0,3.4-2.6,5.4-7.9,5.4c-4.7,0-9.8-2.4-13.9-5.9l-7.3,8.7c5.7,5.4,13.5,8.1,20.8,8.1 c13.5,0,21.2-8.1,21.2-17.4c0-2.3-0.4-4.5-1.3-6.6c-1.2-2.8-3.3-5-5.9-6.6c-0.1,0-0.1-0.1-0.2-0.1c-2.8-1.8-5.7-2.8-8.7-3.9 c-0.7-0.3-1.4-0.5-2-0.8c-4.6-1.8-8.5-4.5-9.4-9.5c0-0.1-0.2-1.3-0.2-2.2L61.7,51z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M68.4,48.9c0,5.5,4.4,9.9,9.9,9.9c5.5,0,9.9-4.4,9.9-9.9c0-5.5-4.4-9.9-9.9-9.9C72.8,39,68.4,43.5,68.4,48.9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.8a2adda3af35c07ad7ec78ebf06472bc.svg";
export { ForwardRef as ReactComponent };